import React from 'react';
import {Trans} from 'react-i18next';
import GeneralSection from './GeneralSection';
import ResultPageSettings from './ResultPageSettings';
import DetectionSummary from './DetectionSummary';
import DetectionCard from './DetectionCard';
import RecommendationSettings from './RecommendationSettings';
import RecommendationTabSettings from './RecommendationTabSettings';
import TextSettings from './TextSettings';

export default function ResultGenericLayoutSettings({
  formikProps,
  device,
  setDevice,
  defaultCardCategory,
  transformedCategories,
  displayRecommendLayout,
}) {
  return (
    <div>
      <GeneralSection formikProps={formikProps} />
      <h4 className="kt-margin-b-20">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skin.report">
          Skin Report
        </Trans>
      </h4>
      <ResultPageSettings formikProps={formikProps} />
      <DetectionSummary formikProps={formikProps} />
      <DetectionCard
        formikProps={formikProps}
        defaultCardCategory={defaultCardCategory}
        transformedCategories={transformedCategories}
      />
      <h4 className="kt-margin-b-20">
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.recommendation">
          Recommendation
        </Trans>
      </h4>
      <RecommendationSettings
        formikProps={formikProps}
        imageType={device}
        setImageType={setDevice}
      />
      <RecommendationTabSettings
        displayRecommendLayout={displayRecommendLayout}
      />
      <TextSettings formikProps={formikProps} />
    </div>
  );
}
